import { useEffect, useRef, useState } from "react";

const useInView = (margin = "-60px") => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let done = false;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          done = true;
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: `0px 0px ${margin} 0px` }
    );
    io.observe(el);
    // Safety fallback: never leave content hidden.
    const fb = setTimeout(() => { if (!done) setInView(true); }, 1400);
    return () => { io.disconnect(); clearTimeout(fb); };
  }, [margin]);
  return [ref, inView];
};

export const Reveal = ({ children, delay = 0, className }) => {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} className={`reveal ${inView ? "is-in" : ""} ${className || ""}`} style={{ transitionDelay: `${delay}s` }}>
      {children}
    </div>
  );
};

export const Hairline = ({ delay = 0, className }) => {
  const [ref, inView] = useInView("-40px");
  return (
    <div ref={ref} className={`hairline-r ${inView ? "is-in" : ""} ${className || ""}`} style={{ transitionDelay: `${delay}s` }} />
  );
};

export const EASE = [0.16, 1, 0.3, 1];
